import config from "./config";

const directory = config.rearrangesentence.directory;
const rearrangeSentence = [
    {
        category: "chongzu_YeVSKeshi",
        link: `${config.flashUrl}/${directory}/chongzu_YeVSKeshi`,
        target: true
    },
    {
        category: "Dou",
        link: `${config.flashUrl}/${directory}/Dou`,
        target: true
    },
    {
        category: "EverydayChineseB1L1",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L1`,
        target: true
    },
    {
        category: "EverydayChineseB1L2D1",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L2D1`,
        target: true
    },
    {
        category: "EverydayChineseB1L2D2",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L2D2`,
        target: true
    },
    {
        category: "EverydayChineseB1L3D2Dia",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L3D2Dia`,
        target: true
    },
    {
        category: "EverydayChineseB1L3D2Voc",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L3D2Voc`,
        target: true
    },
    {
        category: "EverydayChineseB1L4_page84",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L4_page84`,
        target: true
    },
    {
        category: "EverydayChineseB1L6D1Dia",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L6D1Dia`,
        target: true
    },
    {
        category: "EverydayChineseB1L6D1Voc",
        link: `${config.flashUrl}/${directory}/EverydayChineseB1L6D1Voc`,
        target: true
    },
    {
        category: "EverydayChineseB2L15D1_1",
        link: `${config.flashUrl}/${directory}/EverydayChineseB2L15D1_1`,
        target: true
    },
    {
        category: "EverydayChineseB2L15D1_2",
        link: `${config.flashUrl}/${directory}/EverydayChineseB2L15D1_2`,
        target: true
    },
    {
        category: "EverydayChineseB2L16Part1",
        link: `${config.flashUrl}/${directory}/EverydayChineseB2L16Part1`,
        target: true
    },
    {
        category: "TSDX_9_1",
        link: `${config.flashUrl}/${directory}/TSDX_9_1`,
        target: true
    }
];

export default rearrangeSentence;
